import { createReducer, on } from "@ngrx/store";
import { HttpErrorResponse } from "@angular/common/http";
import {
  invitedGroupStudentsListLoad,
  invitedGroupStudentsListLoadFail,
  invitedGroupStudentsListLoadSuccess,
} from "../../actions/admin/invited-group-students.actions";
import { GroupStudents } from "src/app/shared/interfaces/orgadmin/invited-students";
import { deleteInvitationStudentLoadSuccess } from "../../actions/admin/delete-invitation-student.action";

export interface InvitedGroupStudentsListState {
  students: GroupStudents;
  error: HttpErrorResponse | null;
}

const initialState: InvitedGroupStudentsListState = {
  students: null,
  error: null,
};

export const invitedGroupStudentsListReducer = createReducer(
  initialState,
  on(
    invitedGroupStudentsListLoad,
    (state): InvitedGroupStudentsListState => ({
      ...state,
      students: null,
      error: null,
    }),
  ),
  on(
    invitedGroupStudentsListLoadSuccess,
    (state, action): InvitedGroupStudentsListState => ({
      ...state,
      students: action.invitedStudents,
      error: null,
    }),
  ),
  on(
    deleteInvitationStudentLoadSuccess,
    (state, { invitationId }): InvitedGroupStudentsListState => ({
      ...state,
      students: state.students
        ? {
            ...state.students,
            invitations: state.students.invitations.filter(
              (invitation) => invitation.id !== invitationId,
            ),
          }
        : state.students,
    }),
  ),
  on(
    invitedGroupStudentsListLoadFail,
    (state, { error }): InvitedGroupStudentsListState => ({
      ...state,
      error,
    }),
  ),
);
